import { Link } from 'react-router-dom';
import { Sprout } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Sprout className="h-8 w-8 text-green-400" />
              <span className="text-2xl font-bold">AgriMocks</span>
            </div>
            <p className="text-gray-400">
              Empowering the future of agriculture through education and innovation.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: 'Home', path: '/' },
                { name: 'Features', path: '/features' },
                { name: 'Products', path: '/products' },
                { name: 'Testimonials', path: '/testimonials' },
                { name: 'Pricing', path: '/pricing' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-gray-400 hover:text-green-400">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              {[
                { name: 'Blog', path: '#' },
                { name: 'Community', path: '#' },
                { name: 'Support', path: '#' },
                { name: 'Privacy Policy', path: '/privacy-policy' },
                { name: 'Terms', path: '/terms' }
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-green-400"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Newsletter</h4>
            <p className="text-gray-400 mb-4">
              Stay updated with the latest agricultural insights.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-2 rounded-l-lg bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-green-400"
              />
              <button className="px-4 py-2 bg-green-800 hover:bg-green-900 rounded-r-lg transition-colors duration-200" aria-label="Subscribe">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} AgriMocks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 